import CryptoJS from "crypto-js";

/**
 * Reads admin access token from localStorage (AES-encrypted or plain JWT).
 * Never returns the literal strings "undefined" / "null" / empty.
 */
export const decryptToken = (key) => {
  const raw = localStorage.getItem(key);
  if (raw == null) return null;
  const trimmed = String(raw).trim();
  if (!trimmed || trimmed === "undefined" || trimmed === "null") return null;

  if (trimmed.startsWith("eyJ")) {
    return trimmed;
  }

  try {
    const bytes = CryptoJS.AES.decrypt(trimmed, process.env.REACT_APP_CRYPTO_SECRET);
    const out = bytes.toString(CryptoJS.enc.Utf8);
    const s = (out || "").trim();
    if (!s || s === "undefined" || s === "null") return null;
    return s;
  } catch (error) {
    console.error("Token decryption failed", error);
    return null;
  }
};
